export enum VentricularAssistDeviceConstants {
  SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT = 'ventricularAssistDevice/SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT',
  SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT_PNNV = 'ventricularAssistDevice/SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT_PNNV',
  SET_DATE = 'ventricularAssistDevice/SET_DATE',
  SET_TIME = 'ventricularAssistDevice/SET_TIME',
  SET_DATE_TIME = 'ventricularAssistDevice/SET_DATE_TIME',
  SET_PTA = 'ventricularAssistDevice/SET_PTA',
  SET_ASSESSED_BY = 'ventricularAssistDevice/SET_ASSESSED_BY',
  SET_ROLE_PERFORMING = 'ventricularAssistDevice/SET_ROLE_PERFORMING',
  SET_ROLE_PERFORMING_PNNV = 'ventricularAssistDevice/SET_ROLE_PERFORMING_PNNV',
  SET_SUCCESSFUL_ATTEMPT = 'ventricularAssistDevice/SET_SUCCESSFUL_ATTEMPT',
  SET_PROCEDURE_COMPLICATIONS = 'ventricularAssistDevice/SET_PROCEDURE_COMPLICATIONS',
  SET_RESPONSE = 'ventricularAssistDevice/SET_RESPONSE',
  SET_RESPONSE_PNNV = 'ventricularAssistDevice/SET_RESPONSE_PNNV',
  SET_AUTHORIZATION = 'ventricularAssistDevice/SET_AUTHORIZATION',
  SET_COMMENTS = 'ventricularAssistDevice/SET_COMMENTS',
  SET_ADD_TO_TIMELINE = 'ventricularAssistDevice/SET_ADD_TO_TIMELINE',
  SET_VENTRICULAR_ASSIST_DEVICE_TYPE = 'ventricularAssistDevice/SET_VENTRICULAR_ASSIST_DEVICE_TYPE',
  SET_INDICATION = 'ventricularAssistDevice/SET_INDICATION',
  SET_PULSATILITY_INDEX = 'ventricularAssistDevice/SET_PULSATILITY_INDEX',
  SET_AUSCULTATED = 'ventricularAssistDevice/SET_AUSCULTATED',
  SET_MAKE_MODEL_VAD = 'ventricularAssistDevice/SET_MAKE_MODEL_VAD',
  SET_MAKE_MODEL_IMPELLA = 'ventricularAssistDevice/SET_MAKE_MODEL_IMPELLA',
  SET_P_LEVEL = 'ventricularAssistDevice/SET_P_LEVEL',
  SET_SPEED_RPMS = 'ventricularAssistDevice/SET_SPEED_RPMS',
  SET_FLOW_TYPE = 'ventricularAssistDevice/SET_FLOW_TYPE',
  SET_CONTROLLER_NUMBER = 'ventricularAssistDevice/SET_CONTROLLER_NUMBER',
  SET_MOTOR_CURRENT_MA = 'ventricularAssistDevice/SET_MOTOR_CURRENT_MA',
  SET_MOTOR_CURRENT_WAVE_FORM_CHARACTERISTICS = 'ventricularAssistDevice/SET_MOTOR_CURRENT_WAVE_FORM_CHARACTERISTICS',
  SET_PLACEMENT_SIGNAL_MMHG = 'ventricularAssistDevice/SET_PLACEMENT_SIGNAL_MMHG',
  SET_PLACEMENT_SIGNAL_WAVE_FORM_CHARACTERISTICS = 'ventricularAssistDevice/SET_PLACEMENT_SIGNAL_WAVE_FORM_CHARACTERISTICS',
  SET_PLACEMENT_CONFIRMED_BY = 'ventricularAssistDevice/SET_PLACEMENT_CONFIRMED_BY',
  SET_CATHETER_SIZE = 'ventricularAssistDevice/SET_CATHETER_SIZE',
  SET_CATHETER_DEPTH_CM = 'ventricularAssistDevice/SET_CATHETER_DEPTH_CM',
  SET_CATHETER_SERIAL_NUMBER = 'ventricularAssistDevice/SET_CATHETER_SERIAL_NUMBER',
  SET_INSERT_LOCATION = 'ventricularAssistDevice/SET_INSERT_LOCATION',
  SET_PLACEMENT_LOCATION = 'ventricularAssistDevice/SET_PLACEMENT_LOCATION',
  SET_SITE_ASSESSMENT = 'ventricularAssistDevice/SET_SITE_ASSESSMENT',
  SET_LEG_IMMOBILIZED = 'ventricularAssistDevice/SET_LEG_IMMOBILIZED',
  SET_CATHETER_SUTURED_IN_PLACE = 'ventricularAssistDevice/SET_CATHETER_SUTURED_IN_PLACE',
  SET_DRESSING_CONDITION = 'ventricularAssistDevice/SET_DRESSING_CONDITION',
  SET_PULSES_DISTAL_TO_INSERTION_SITE = 'ventricularAssistDevice/SET_PULSES_DISTAL_TO_INSERTION_SITE',
  SET_ANCHORING_RING_LOCKED = 'ventricularAssistDevice/SET_ANCHORING_RING_LOCKED',
  SET_HEAD_OF_BED_AT_30_DEGREES = 'ventricularAssistDevice/SET_HEAD_OF_BED_AT_30_DEGREES',
  SET_ANTICOAGULATION = 'ventricularAssistDevice/SET_ANTICOAGULATION',
  SET_ANTIDYSRHYTHMIA = 'ventricularAssistDevice/SET_ANTIDYSRHYTHMIA',
  SET_PURGE_SOLUTION_DEXTROSE_PERCENT = 'ventricularAssistDevice/SET_PURGE_SOLUTION_DEXTROSE_PERCENT',
  SET_PURGE_SOLUTION_HEPARIN_IU_ML = 'ventricularAssistDevice/SET_PURGE_SOLUTION_HEPARIN_IU_ML',
  SET_PURGE_SOLUTION_FLOW_ML_HR = 'ventricularAssistDevice/SET_PURGE_SOLUTION_FLOW_ML_HR',
  SET_PRESSURE_BAG_USED = 'ventricularAssistDevice/SET_PRESSURE_BAG_USED',
  SET_PURGE_PRESSURE_MMHG = 'ventricularAssistDevice/SET_PURGE_PRESSURE_MMHG',
  SET_FLOW_L_MIN = 'ventricularAssistDevice/SET_FLOW_L_MIN',
  SET_POWER_WATTS = 'ventricularAssistDevice/SET_POWER_WATTS',
  SET_POWER_TYPE = 'ventricularAssistDevice/SET_POWER_TYPE',
  SET_BATTERY_STATUS = 'ventricularAssistDevice/SET_BATTERY_STATUS',
  SET_BACKUP_OPTIONS = 'ventricularAssistDevice/SET_BACKUP_OPTIONS',
  SET_ALARMS = 'ventricularAssistDevice/SET_ALARMS',
  SET_VAD_COORDINATOR_NOTIFICATION = 'ventricularAssistDevice/SET_VAD_COORDINATOR_NOTIFICATION',
  SET_INFLOW_CANNULA_SITE_ASSESSMENT = 'ventricularAssistDevice/SET_INFLOW_CANNULA_SITE_ASSESSMENT',
  SET_OUTFLOW_CANNULA_SITE_ASSESSMENT = 'ventricularAssistDevice/SET_OUTFLOW_CANNULA_SITE_ASSESSMENT',
  SET_HIDE_VAD_FIELDS = 'ventricularAssistDevice/SET_HIDE_VAD_FIELDS',
  SET_HIDE_IMPELLA_FIELDS = 'ventricularAssistDevice/SET_HIDE_IMPELLA_FIELDS',
  SET_UPDATE_INPUT_ROWS = 'ventricularAssistDevice/SET_UPDATE_INPUT_ROWS',
  SET_STATE = 'ventricularAssistDevice/SET_STATE',
  ON_SELECT_VENTRICULAR_ASSIST_DEVICE = 'ventricularAssistDevice/ON_SELECT_VENTRICULAR_ASSIST_DEVICE',
  SAVE_VENTRICULAR_ASSIST_DEVICE = 'ventricularAssistDevice/SAVE_VENTRICULAR_ASSIST_DEVICE',
  CLEAR_FIELDS = 'ventricularAssistDevice/CLEAR_FIELDS',
  RESET_STATE = 'ventricularAssistDevice/RESET_STATE',
}
